"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * 権限制御に関するユーティリティ
 */

/**
 * 利用許可を保有しているか（利用許可属性に識別子が含まれるか）を判定する。(完全一致)
 * @param {string} permissions 利用許可属性（カンマ区切り）
 * @param {string} identifier  判定対象の識別子
 * @returns {boolean} 判定結果（true：利用許可を保有している、false：利用許可を保有していない）
 */
const hasPermission = (permissions, identifier) => {
  if (!permissions || !identifier) {
    return false;
  }
  const permissionList = permissions.split(',');
  for (var permission of permissionList) {
    if (permission === identifier) {
      return true;
    }
  }
  return false;
};

/**
 * 会社／組織選択の利用許可属性から会社／組織選択の初期値を取得する。
 * @param {string} permissions 利用許可属性（カンマ区切り）
 * @param {string} soshikiCd   ログインユーザの所属組織の組織コード
 * @returns {string} 会社／組織選択の初期値となる組織コード
 */
const getInitialSoshikiCd = (permissions, soshikiCd) => {
  let initialSoshikiCd = '';
  if (!permissions || !soshikiCd) {
    return initialSoshikiCd;
  }
  const permissionList = permissions.split(',');
  permissionList.forEach(item => {
    if (item.startsWith('kaishasoshiki:select:')) {
      if (!initialSoshikiCd && item.endsWith('my_soshiki_last')) {
        initialSoshikiCd = sliceSoshikiCd(soshikiCd, 5);
      } else {
        initialSoshikiCd = sliceSoshikiCd(soshikiCd, 4);
      }
    }
  });
  return initialSoshikiCd;
};

/** 指定した部門レベルの組織コードに変換する */
const sliceSoshikiCd = (soshikiCd, bumonLv) => {
  const res = String(soshikiCd).split('-', bumonLv).join('-');
  return res ? res : '';
};
var _default = exports.default = {
  hasPermission,
  getInitialSoshikiCd
};